"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (event) {
    event.preventDefault();
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/utils/preventDefault.js
// module id = /lBP
// module chunks = 46